'use strict';

import EN from "./texts.en";
import DE from "./texts.de"
import State from "./state";

let Labels = {
    initialized: false,
    
    get (name) {
        if (this.initialized === false) this.init();
        if (this.hasOwnProperty(name)) return this[name];
        return "Undefined";
    },
    init() {
        let lang = this.detectLanguage();
        console.log(`Detected language: ${lang}`);

        State.language = lang;
        //we first copy the languages from the correct source
        const srcTexts = lang === "de" ? DE : EN;

        for (let text in srcTexts) {
            if (srcTexts.hasOwnProperty(text)) {
                this[text] = srcTexts[text];
            }
        }

        //we check if any of these labels has been overwritten in the host html page
        let labelEls = document.querySelectorAll(".assw-params > .labels > input[type='hidden']");
        if (labelEls && labelEls.length > 0) {
            for (let i = 0; i < labelEls.length; i++) {
                const el = labelEls[i];
                this[el.name] = el.value;
            };
        }
        this.initialized = true;
    },
    detectLanguage () {
        let lang = "en";
        document.body.className.split(" ").map(c => {
            if (c.indexOf("lang-") !== -1) {
                lang = c.substring(5);
            }
        });
        return lang;
    }
};

export default Labels;